import { render, staticRenderFns } from "./commodityView.vue?vue&type=template&id=3a9e534a&scoped=true"
import script from "./commodityView.vue?vue&type=script&lang=js"
export * from "./commodityView.vue?vue&type=script&lang=js"
import style0 from "./commodityView.vue?vue&type=style&index=0&id=3a9e534a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e534a",
  null
  
)

export default component.exports